import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/layout/SiteShell";
import { BlogArticleTemplate } from "@/components/BlogArticleTemplate";
import { articleBySlug } from "@/data/blog";
import { breadcrumbSchema, faqSchema, jsonLd, SITE_URL, absUrl } from "@/lib/seo";

const SLUG = "vad-ska-man-saga-till-barberaren-fade";
const article = articleBySlug[SLUG]!;

export const Route = createFileRoute("/vad-ska-man-saga-till-barberaren-fade")({
  head: () => ({
    meta: [
      { title: `${article.title} | Tailor's Barber` },
      { name: "description", content: article.metaDescription },
      { property: "og:title", content: article.title },
      { property: "og:description", content: article.metaDescription },
      { property: "og:type", content: "article" },
      { property: "og:image", content: absUrl(article.hero) },
      { property: "og:url", content: absUrl(`${SITE_URL}/${SLUG}`) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absUrl(article.hero) },
    ],
    links: [{ rel: "canonical", href: absUrl(`${SITE_URL}/${SLUG}`) }],
    scripts: [
      jsonLd({
        "@context": "https://schema.org",
        "@type": "Article",
        headline: article.title,
        description: article.metaDescription,
        image: absUrl(article.hero),
        datePublished: article.publishedAt,
        author: { "@type": "Organization", name: "Tailor's Barber", url: SITE_URL },
        publisher: { "@type": "Organization", name: "Tailor's Barber", url: SITE_URL },
        mainEntityOfPage: `${SITE_URL}/${SLUG}`,
      }),
      jsonLd(faqSchema(article.faq)),
      jsonLd(
        breadcrumbSchema([
          { name: "Hem", url: "/" },
          { name: "Inspiration", url: "/blogg" },
          { name: article.title, url: `/${SLUG}` },
        ]),
      ),
    ],
  }),
  component: () => (
    <SiteShell>
      <BlogArticleTemplate article={article} />
    </SiteShell>
  ),
});
